module.exports = __webpack_public_path__ + "number2.png?3be763b63fd5c43a552a1a21f47f387d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/number2.png
// module id = 3
// module chunks = 0